import { uploadAIDubbingVideo } from "../../api/aidubbing";
import {
  setSelectedVideo,
  setSelectedVideoUrl,
} from "../../store/AiDubbing/AiDubbingSlice";
import { setIdle, setLoading } from "../../store/common/appStateSlice";
import { setLoaderValue } from "../../store/editor/canvasSlice";
import { showToast } from "../../utils/general";

export const createAIDubbingVideo =
  (data, navigate) => async (dispatch, getState) => {
    try {
      const { selectedVideo } = getState().aiDubbing;

      dispatch(setLoading());

      const aidubbingAPIResponse = await uploadAIDubbingVideo(
        selectedVideo,
        data
      );
      if (aidubbingAPIResponse?.status === 200) {
        showToast(aidubbingAPIResponse?.data?.message);
        dispatch(setSelectedVideo(null));
        dispatch(setSelectedVideoUrl(""));
        dispatch(setLoaderValue(100));
        // navigate("/");
      } else {
        showToast("Something Went Wrong", "", "danger");
      }

      dispatch(setIdle());

      // Call the callback function if passed
      // if (cb) {
      //   cb();
      // }
    } catch (error) {
      console.error("Error while creating AI Dubbing video", error);
      showToast("Something went wrong", "", "danger");
      dispatch(setIdle());
    }
  };
